import { bootstrapApplication } from '@angular/platform-browser';
import {environment} from "@src/environments/environment";
import {enableProdMode} from "@angular/core";
import {WebAppComponent} from "./web-app/web-app.component";
import {WEB_APP_BROWSER_CONFIG} from "./web-app/web-app.browser.config";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(WebAppComponent, WEB_APP_BROWSER_CONFIG).catch((err) =>
  console.error(err)
);
